import { CmsCollectionClient, CmsCustomerClient } from './Cms.client';
import { StoreCollectionClient, StoreCustomerClient } from './Store.client';
import { CategoriesAndGamesType, CollectionType } from 'src/domains/casino/types/types';
import { Common } from 'src/domains/common/Common';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';

interface GameClientType {
    collectionMap: AutoMap<CollectionType, CollectionClientType>;
    customer: CustomerClientType;
}

export interface CollectionClientType {
    isLoading: boolean;
    categoriesAndGames: CategoriesAndGamesType;
}
export interface CustomerClientType {
    recentGamesIds: Array<number>;
    isLoadingRecent: boolean;
    setRecentGame: (gameId: number) => void;
    isLoadingFavourites: boolean;
    favouriteGamesIds: Array<number>;
    setFavouriteGame: (gameId: number, isFavourite: boolean) => void;
}

class CollectionClient implements CollectionClientType {
    private httpClient: CollectionClientType;

    public constructor(
        private readonly collection: CollectionType,
        private readonly common: Common
    ) {
        switch (this.common.features.casinoStore) {
            case true:
                this.httpClient = new StoreCollectionClient(this.collection, this.common);
                break;
            case false:
                this.httpClient = new CmsCollectionClient(this.collection, this.common);
                break;
        }
    }

    public get categoriesAndGames(): CategoriesAndGamesType {
        return this.httpClient.categoriesAndGames;
    }

    public get isLoading(): boolean {
        return this.httpClient.isLoading;
    }
}

class CustomerClient implements CustomerClientType {
    private httpClient: CustomerClientType;

    public constructor(private readonly common: Common) {
        switch (this.common.features.casinoStore) {
            case true:
                this.httpClient = new StoreCustomerClient(this.common);
                break;
            case false:
                this.httpClient = new CmsCustomerClient(this.common);
                break;
        }
    }

    public get recentGamesIds(): Array<number> {
        return this.httpClient.recentGamesIds;
    }

    public get isLoadingRecent(): boolean {
        return this.httpClient.isLoadingRecent;
    }

    public setRecentGame = (gameId: number): void => {
        this.httpClient.setRecentGame(gameId);
    };

    public get favouriteGamesIds(): number[] {
        return this.httpClient.favouriteGamesIds;
    }
    public get isLoadingFavourites(): boolean {
        return this.httpClient.isLoadingFavourites;
    }
    public setFavouriteGame = (gameId: number, isFavourite: boolean): void => {
        return this.httpClient.setFavouriteGame(gameId, isFavourite);
    };
}

export class GameClient implements GameClientType {
    public collectionMap: AutoMap<CollectionType, CollectionClient>;
    public customer: CustomerClientType;

    public constructor(private readonly common: Common) {
        this.collectionMap = new AutoMap((collection: CollectionType) => new CollectionClient(collection, this.common));
        this.customer = new CustomerClient(this.common);
    }
}
